import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X, ChevronRight, LayoutDashboard, Calendar, BookOpen, Dumbbell, MessageSquare, Truck, Bell, Megaphone, FileText, Newspaper, Users, FolderGit2, MapPin, Printer, Settings } from 'lucide-react';
import './CommandPalette.scss';

const ALL_NAV_ITEMS = [
  { to: '/', title: 'Ana Sayfa & Analitik', category: 'Genel', icon: LayoutDashboard },
  { to: '/sports/activity-logs', title: 'Aktivite Kayıtları', category: 'Genel', icon: FileText },
  { to: '/mobile-notifications', title: 'Mobil Bildirimler', category: 'Genel', icon: Bell },
  { to: '/report-incidents', title: 'Bize Bildir Yönetimi', category: 'Vatandaş & Talep', icon: MessageSquare },
  { to: '/sitas', title: 'SİTAS Operasyon', category: 'Hizmetler', icon: Truck },
  { to: '/neighborhood-developments', title: 'Mahallem Gelişiyor', category: 'Hizmetler', icon: MapPin },
  { to: '/library-appointments', title: 'Kütüphane Randevuları', category: 'Kültür & Spor', icon: Calendar },
  { to: '/books', title: 'Kitap Yönetimi', category: 'Kültür & Spor', icon: BookOpen },
  { to: '/sports-appointments', title: 'Spor Randevuları', category: 'Kültür & Spor', icon: Dumbbell },
  { to: '/club-applications', title: 'Kart Başvuruları', category: 'Kültür & Spor', icon: FileText },
  { to: '/announcements', title: 'Duyurular', category: 'İçerik Yönetimi', icon: Megaphone },
  { to: '/news', title: 'Haberler', category: 'İçerik Yönetimi', icon: Newspaper },
  { to: '/events', title: 'Etkinlikler', category: 'İçerik Yönetimi', icon: Calendar },
  { to: '/tenders', title: 'İhaleler', category: 'İçerik Yönetimi', icon: FileText },
  { to: '/projects', title: 'Proje Yönetimi', category: 'İçerik Yönetimi', icon: FolderGit2 },
  { to: '/parlament-members', title: 'Meclis Üyeleri', category: 'Yönetim', icon: Users },
  { to: '/managers', title: 'Müdürlerimiz', category: 'Yönetim', icon: Users },
  { to: '/printers', title: 'Toner Yönetimi', category: 'Sistem', icon: Printer },
  { to: '/settings', title: 'Ayarlar', category: 'Sistem', icon: Settings },
];

const CommandPalette = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (isOpen) {
          onClose();
        } else {
          // Trigger open via parent
          window.dispatchEvent(new CustomEvent('toggle-command-palette'));
        }
      }
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  const filteredItems = useMemo(() => {
    if (!query.trim()) return ALL_NAV_ITEMS;
    const q = query.toLowerCase();
    return ALL_NAV_ITEMS.filter(
      (item) => item.title.toLowerCase().includes(q) || item.category.toLowerCase().includes(q)
    );
  }, [query]);

  const handleSelect = (to) => {
    onClose();
    setQuery('');
    navigate(to);
  };

  if (!isOpen) return null;

  return (
    <div className="arc-command-backdrop" onClick={onClose}>
      <div className="arc-command-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="arc-command-input-row">
          <Search size={18} className="arc-command-search-icon" />
          <input
            type="text"
            className="arc-command-input"
            placeholder="Sayfa veya işlem ara... (örn: Duyurular, Spor, Randevu)"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoFocus
          />
          <button type="button" className="arc-command-close-btn" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="arc-command-list">
          {filteredItems.length === 0 ? (
            <div className="arc-command-empty">Eşleşen sonuç bulunamadı</div>
          ) : (
            filteredItems.map((item, index) => {
              const Icon = item.icon;
              return (
                <button
                  type="button"
                  key={index}
                  className="arc-command-item"
                  onClick={() => handleSelect(item.to)}
                >
                  <div className="arc-command-item-left">
                    <span className="arc-command-icon-badge">
                      <Icon size={16} />
                    </span>
                    <span className="arc-command-item-title">{item.title}</span>
                  </div>
                  <div className="arc-command-item-right">
                    <span className="arc-command-category-pill">{item.category}</span>
                    <ChevronRight size={14} className="arc-command-chevron" />
                  </div>
                </button>
              );
            })
          )}
        </div>

        <div className="arc-command-footer">
          <span>Seçmek için tıklayın veya Enter'a basın</span>
          <kbd>ESC</kbd>
        </div>
      </div>
    </div>
  );
};

export default CommandPalette;
